import { Button as o, buttonClasses as r, linkClasses as g } from "@mui/material";
import { styled as l, css as n } from "./styled2.mjs";
const a = (e) => n`
		${({ theme: i }) => {
  let t = "none";
  switch (e) {
    case "secondary":
      t = i.tokens.FocusRing["FocusRing-Secondary"];
      break;
    case "error":
      t = i.tokens.FocusRing["FocusRing-Error"];
      break;
    case "primary":
    default:
      t = i.tokens.FocusRing["FocusRing-Primary"];
  }
  return t;
}}
	`, d = (e, i) => n`
	background: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};
	border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};
	color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].contrast};

	&.${r.root} {
		box-shadow: ${({ theme: t }) => t.tokens.shadow.small};
	}

	&:hover:where(:not(:disabled)) {
		background: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].dark};
		border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].dark};
	}

	&:active {
		background: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].light};
		border-color: ${({ theme: t }) => t.palette.other.outlinedBorder};
	}

	&:focus-visible {
		background: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};
		border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};
		outline: ${({ theme: t }) => `${t.spacing(0.5)} solid ${e === "inherit" ? "inherit" : t.palette[e].main08}`};
		box-shadow: ${a(e)};
	}

	&:disabled,
	&[aria-disabled='true'] {
		background: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main30};
		border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main30};
		color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].contrast};
	}
`, $ = (e, i) => n`
	background: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main08};
	border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].light};
	color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].light};

	&.${r.root} {
		box-shadow: ${({ theme: t }) => t.tokens.shadow.small};
	}

	&:hover:where(:not(:disabled)) {
		background: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main30};
		border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].light};
	}

	&:active {
		background: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main08};
		border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main08};
	}

	&:focus-visible {
		background: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main08};
		border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].light};
		outline: ${({ theme: t }) => `${t.spacing(0.5)} solid ${e === "inherit" ? "inherit" : t.palette[e].main08}`};
		box-shadow: ${a(e)};
	}

	&:disabled {
		background: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].contrast};
		border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].contrast};
		color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main30};
	}
`, b = () => n`
	background: ${({ theme: e }) => e.palette.background.level3};
	border-color: ${({ theme: e }) => e.palette.grey[300]};
	color: ${({ theme: e }) => e.palette.text.body};

	&.${r.root} {
		box-shadow: ${({ theme: e }) => e.tokens.shadow.small};
	}

	&:hover:where(:not(:disabled)) {
		background: ${({ theme: e }) => e.palette.background.level1};
		border-color: ${({ theme: e }) => e.palette.grey[400]};
	}

	&:active {
		background: ${({ theme: e }) => e.palette.background.level3};
		border-color: ${({ theme: e }) => e.palette.grey[500]};
	}

	&:focus-visible {
		background: ${({ theme: e }) => e.palette.background.level3};
		border-color: ${({ theme: e }) => e.palette.grey[400]};
		outline: ${({ theme: e }) => `${e.spacing(0.5)} solid ${e.palette.grey[100]}`};
		box-shadow: ${({ theme: e }) => e.tokens.FocusRing["FocusRing-Secondary"]};
	}

	&:disabled {
		background: ${({ theme: e }) => e.palette.background.level3};
		border-color: ${({ theme: e }) => e.palette.grey[100]};
		color: ${({ theme: e }) => e.palette.text.disabled};

		svg {
			opacity: 0.5;
		}
	}
`, u = (e, i) => n`
	background: transparent;
	border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};
	color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};

	svg {
		color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};
	}

	&:hover:where(:not(:disabled)) {
		background: ${({ theme: t }) => t.palette.background.level1};
		border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};
		color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].dark};

		svg {
			color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].dark};
		}
	}

	&:active {
		background: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main08};
		border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};
		color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].light};

		svg {
			color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};
			opacity: 0.8;
		}
	}

	&:focus-visible {
		background: ${({ theme: t }) => t.palette.background.level3};
		border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};
		outline: ${({ theme: t }) => `${t.spacing(0.5)} solid ${e === "inherit" ? "inherit" : t.palette[e].main30}`};
		box-shadow: ${a(e)};

		svg {
			color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].light};
		}
	}

	&:disabled {
		background: ${({ theme: t }) => t.palette.background.level3};
		border-color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main08};
		color: ${({ theme: t }) => t.palette.text.disabled};

		svg {
			color: ${({ theme: t }) => t.palette.text.disabled};
		}
	}
`, c = (e, i, t) => i === "error" && t === "white" ? e.palette.error.contrast : t === "white" ? e.palette.primary.contrast : t === "grey" ? e.palette.grey[700] : i === "inherit" ? "inherit" : e.palette[i].main, s = (e, i, t) => i === "error" && t === "white" ? e.palette.error.main08 : t === "white" ? e.palette.primary.main08 : t === "grey" ? e.palette.grey[800] : i === "inherit" ? "inherit" : e.palette[i].dark, k = (e, i, t) => i === "error" && t === "white" ? e.palette.error.main30 : t === "white" ? e.palette.primary.main30 : t === "grey" ? e.palette.grey[600] : i === "inherit" ? "inherit" : e.palette[i].main, h = (e, i, t) => i === "error" && t === "white" ? e.palette.error.contrast : t === "white" ? e.palette.primary.contrast : t === "grey" ? e.palette.grey[700] : i === "inherit" ? "inherit" : e.palette[i].light, p = (e, i) => n`
	background: transparent;
	border-color: transparent;
	color: ${({ theme: t }) => c(t, e, i)};

	padding: 0;
	min-width: unset;

	svg {
		color: ${({ theme: t }) => e === "inherit" ? "inherit" : t.palette[e].main};
	}

	&:hover:where(:not(:disabled)) {
		background: transparent;
		color: ${({ theme: t }) => s(t, e, i)};

		svg {
			color: ${({ theme: t }) => s(t, e, i)};
		}
	}

	&:active {
		opacity: 0.8;
		background: transparent;
		color: ${({ theme: t }) => k(t, e, i)};
	}

	&:focus-visible {
		background: transparent;
		box-shadow: ${({ theme: t }) => t.tokens.shadow.small};
		color: ${({ theme: t }) => h(t, e, i)};

		svg {
			color: ${({ theme: t }) => h(t, e, i)};
		}
	}

	&:disabled {
		background: transparent;
		color: ${({ theme: t }) => t.palette.text.disabled};

		svg {
			color: ${({ theme: t }) => t.palette.text.disabled};
		}
	}
`, m = {
  primary: d,
  secondary: $,
  tertiary: b,
  outlined: u,
  link: p,
  // support for legacy variants
  contained: d,
  text: p
}, y = {
  large: 8,
  medium: 6.5,
  small: 4.5,
  xsmall: 4
}, x = l(o)`
	pointer-events: ${({ $isLoading: e }) => e ? "none" : "all"};

	padding-block: 0;
	padding-inline: ${({ theme: e }) => e.spacing(2)};

	height: ${({ $size: e, $variant: i, theme: t }) => i !== "link" ? t.spacing(y[e]) : "unset"};

	${({ $variant: e, $size: i, $iconButton: t }) => {
  if (t)
    return n`
				aspect-ratio: 1;
				min-width: unset;

				.${r.startIcon}, .${r.endIcon} {
					margin-right: 0;
					margin-left: 0;
				}
			`;
  if (e !== "link" && e !== "text") {
    if (i === "large")
      return n`
					min-width: 117px;
				`;
    if (i === "medium")
      return n`
					min-width: 117px;
				`;
    if (i === "small")
      return n`
					min-width: 81px;
				`;
    if (i === "xsmall")
      return n`
					min-width: 72px;
				`;
  }
}};

	border: 1px solid;

	${({ $variant: e, $color: i, $linkColor: t }) => m[e](i, t)};

	&.${g.root} {
		text-decoration: none;
	}

	& > .${r.startIcon}, .${r.endIcon} {
		opacity: ${({ $isLoading: e }) => e ? 0 : 1};
	}
`, f = l("div")`
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	visibility: visible;
	left: 50%;
	transform: translate(-50%);
`;
export {
  x as ButtonStyled,
  f as LoaderWrapper
};
//# sourceMappingURL=styles12.mjs.map
